module.exports = __webpack_public_path__ + "static/img/SketchPngfa4e922d0e743f5f8661ce0ee72627bb9cf59116fe2db4c693cef816aba34a84.6b4b05cf.png";